import ModuleBundle from 'src/config/models/ModuleBundle';
import {
  StationDashboardModule,
  StationReportModule
} from './StationDashboard/module';
import { JobWiseReportModule } from './JobWiseReport/module';
import { UserWiseReportModule } from './UserWiseReport/module';

export {
  StationDashboardModule,
  StationReportModule,
  JobWiseReportModule,
  UserWiseReportModule
};

export const SessionReportModules = [
  StationDashboardModule,
  JobWiseReportModule,
  UserWiseReportModule
];

export default new ModuleBundle('SessionReport', SessionReportModules);
